import React from "react";
import classNames from "classnames";
import styles from "./EditableTable.module.scss"; // You can pass this in as prop if needed
import { useHeaderSelection } from "./useHeaderSelection";

interface Props {
    isEditable?: boolean;
    columns: string[];
    numberOfCellsPerLine: number;
    editableGridCols: string;
}

export const SharedTableHeader = <T,>({
    isEditable = true,
    columns,
    numberOfCellsPerLine,
    editableGridCols,
}: Props) => {
    const { setSelectedAreaForColumn, isFullColumnSelected, headerRef } =
        useHeaderSelection<T>(numberOfCellsPerLine);

    const titleClass = "title small " + styles.editableTableTitle;

    return (
        <div
            ref={headerRef}
            className={styles.editableTableHeader}
            style={
                {
                    "--grid-template-columns": isEditable
                        ? editableGridCols
                        : "var(--non-editable-grid-cols)",
                } as any
            }
        >
            <div
                onClick={(e) => setSelectedAreaForColumn(e, 0)}
                className={classNames(
                    styles.editableTableHeaderCell,
                    isFullColumnSelected(0)
                        ? styles.editableTableCellSelected
                        : "",
                )}
            />

            {columns.map((title, idx) => (
                <div
                    key={idx + 1}
                    onClick={(e) => setSelectedAreaForColumn(e, idx + 1)}
                    className={classNames(
                        styles.editableTableHeaderCell,
                        isFullColumnSelected(idx + 1)
                            ? styles.editableTableCellSelected
                            : "",
                    )}
                >
                    <p className={titleClass}>{title}</p>
                </div>
            ))}

            {isEditable && <div className={styles.editableTableHeaderCell} />}
        </div>
    );
};
